export enum ChartType {
  BTCDominance = 'BTC_Dominance',
  Total_Volume = 'Total_Volume',
  TVLPerProtocols = 'TVL_per_Protocols',
  USDStablecoinMarketCap = 'USD_Stablecoin_Marketcap',
  TVLPerBlockChain = 'TVL_per_Blockchain',
  Top5CMC = 'Top5_CMC ',
  Spot_ETF_BTC_AUM_USD = 'Spot_ETF_BTC_AUM_USD',
  Spot_ETF_ETH_AUM_USD = 'Spot_ETF_ETH_AUM_USD',
  Spot_ETF_ETH_Flows_USD = 'Spot_ETF_ETH_Flows_USD',
  Spot_ETF_BTC_Flows_USD = 'Spot_ETF_BTC_Flows_USD',
  Spot_ETF_BTC_Total_AUM_Native = 'Spot_ETF_BTC_Total_AUM_Native',
  Spot_ETF_BTC_AUM_Native = 'Spot_ETF_BTC_AUM_Native',
  Spot_ETF_ETH_AUM_Native = 'Spot_ETF_ETH_AUM_Native',
  Spot_ETF_ETH_MarketShare = 'Spot_ETF_ETH_MarketShare',
  Spot_ETF_BTC_Total_AUM_USD = 'Spot_ETF_BTC_Total_AUM_USD',
  Spot_ETF_BTC_MarketShare = 'Spot_ETF_BTC_MarketShare',
  Spot_ETF_ETH_Total_AUM_USD = 'Spot_ETF_ETH_Total_AUM_USD',
  Spot_ETF_ETH_Total_AUM_Native = 'Spot_ETF_ETH_Total_AUM_Native'
}